export default __webpack_public_path__ + "static/media/tokenDemandTxtMb.cc02186b.png";